export const SERVER = process.env.REACT_APP_TYPE ?? "dev";
